import { render, staticRenderFns } from "./MemberDetails.vue?vue&type=template&id=660a4b4a&scoped=true"
import script from "./MemberDetails.vue?vue&type=script&lang=js"
export * from "./MemberDetails.vue?vue&type=script&lang=js"
import style0 from "./MemberDetails.vue?vue&type=style&index=0&id=660a4b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a4b4a",
  null
  
)

export default component.exports